import { createRouter, createWebHistory } from 'vue-router';
import RegisterView from '../views/RegisterView.vue';
import ResetPassword from '../views/ResetPassword.vue';
import SendAuthentication from '../views/SendAuthentication.vue'
import LineLoginView from '../views/LineLoginView.vue';
import PhotoBoardView from '../views/PhotoBoardView.vue';
import BatchView from '../views/BatchView.vue';

const routes = [
  {
    path: '/',
    name: 'home',
    redirect: '/Line-login',
  },
  {
    path: '/Line-login',
    name: 'Line-login',
    component: LineLoginView,
  },
  {
    path: '/register',
    name: 'register',
    component: RegisterView,
  },
  {
    path: '/photoBoard',
    name: 'photoBoard',
    component: PhotoBoardView,
  },
  {
    path: '/batch',
    name: 'batch',
    component: BatchView,
  },
  {
    path: '/reset-password/:key_certificate',
    name: 'resetPassword',
    component: ResetPassword,
  },
  {
    path: '/sendAuthentication',
    name: 'sendAuthentication',
    component: SendAuthentication,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {

  const token = localStorage.getItem("token");
  const whiteList = ['Line-login', 'resetPassword', 'sendAuthentication', 'register', 'photoBoard'];

  if (!token && !whiteList.includes(to.name)) {
    next('/Line-login');
  } else {
    next();
  }

});


export default router;
